import React, { useState, useEffect } from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { Typography } from '@mui/material';

const ProtectedRoute = ({ role }) => {
    const [isAuthorized, setIsAuthorized] = useState(null); // null = still verifying
    // console.log('protected route...')
    useEffect(() => {
        const token = localStorage.getItem('token');
        const expiryTime = Number(localStorage.getItem('tokenExpiry'));

        if (!token || !expiryTime || Date.now() > expiryTime) {
            localStorage.removeItem('token');
            localStorage.removeItem('tokenExpiry');
            setIsAuthorized(false); // Mark as unauthorized
            return;
        }

        const verifyRole = async () => {
            try {
                const response = await fetch(process.env.REACT_APP_API_URL + '/api/decode-token', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    body: JSON.stringify({ token }),
                });

                const data = await response.json();
                console.log('decoded token: ' + JSON.stringify(data))
                console.log('role passed props: ' + role + ' data role: ' + data.decoded.role)
                console.log(response.ok)
                setIsAuthorized(response.ok && data.decoded.role === role);
            } catch (error) {
                console.error('Error verifying token:', error);
                setIsAuthorized(false);
            }
        };

        verifyRole();
    }, [role]);

    if (isAuthorized === null) {
        return <Typography>Verifying...</Typography>;
    }

    if (!isAuthorized) {
        console.log('not authorised')
        return <Navigate to="/login" replace />;
    }

    return <Outlet />;
};




export { ProtectedRoute };

